// services/allergy.service.ts
import { apiService } from "./../../app.service";

export const allergyApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Fetch all allergies with location
    fetchAllergy: builder.query({
      query: (locationId) => {
        const params = locationId ? `?locationId=${locationId}` : '';
        return {
          url: `/allergy${params}`,
        };
      },
      providesTags: ["allergies"],
    }),

    // ✅ Search allergies with location
    fetchAllergyBySearch: builder.mutation({
      query: ({ params, locationId }) => ({
        url: `/allergy/search${locationId ? `?locationId=${locationId}` : ''}`,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["allergies"],
    }),

    // ✅ Create allergy (location handled by backend)
    createAllergy: builder.mutation({
      query: (data) => ({
        url: "/allergy",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["allergies"],
    }),

    // ✅ Fetch allergy by ID with location
    fetchAllergyById: builder.query({
      query: ({ id, locationId }) => ({
        url: `/allergy/${id}${locationId ? `?locationId=${locationId}` : ''}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "allergy", id: result._id }] : [],
    }),

    // ✅ Update allergy with location
    updateAllergy: builder.mutation({
      query: ({ id, data, locationId }) => ({
        url: `/allergy/${id}${locationId ? `?locationId=${locationId}` : ''}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "allergy", id },
        "allergies",
      ],
    }),

    // ✅ Delete allergy with location
    deleteAllergy: builder.mutation({
      query: ({ id, locationId }) => ({
        url: `/allergy/${id}${locationId ? `?locationId=${locationId}` : ''}`,
        method: "DELETE",
      }),
      invalidatesTags: ["allergies"],
    }),

    // ✅ Fetch allergy chart with location
    fetchAllergyChart: builder.query({
      query: (locationId) => ({
        url: `/allergy-matrix${locationId ? `?locationId=${locationId}` : ''}`,
        responseHandler: async (response) => {
          const blob = await response.blob();
          return URL.createObjectURL(blob);
        },
      }),
    }),

    // ✅ Upload allergy chart with location
    uploadAllergyChart: builder.mutation({
      query: ({ pdfFile, locationId }) => {
        const formData = new FormData();
        formData.append("file", pdfFile);
        return {
          url: `/allergy-matrix${locationId ? `?locationId=${locationId}` : ''}`,
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const {
  useFetchAllergyQuery,
  useFetchAllergyBySearchMutation,
  useCreateAllergyMutation,
  useFetchAllergyByIdQuery,
  useUpdateAllergyMutation,
  useDeleteAllergyMutation,
  useFetchAllergyChartQuery,
  useUploadAllergyChartMutation,
} = allergyApi;